module.exports = __webpack_public_path__ + "img/igud-small.d1d82c8f.svg";